<script>
    import Stroke from "./Stroke.svelte";
    import {createEventDispatcher} from "svelte";
    import Color from "./Color.svelte";
    import Slider from "./Slider.svelte";

    export let style;

    $: image = style && style.image || {};

    $: radius = image.radius;
    $: fill = image.fill;
    $: fillColor = fill.color;
    $: stroke = image.stroke;

    const dispatch = createEventDispatcher();

    $: onChange = (changed) => {
        const newStyle = {
            radius,
            fill,
            stroke,
            ...changed
        }

        dispatch('changeStyle', {
            image: {
                ...image,
                ...newStyle
            }
        })
    }

    function changeFillColor({detail: color}) {
        onChange({
            fill: {
                ...fill,
                color
            }
        });
    }

    function changeRadius(ev) {
        onChange({radius: ev.target.value / 2});
    }
</script>

<label>
    Size&nbsp;
    <Slider value={radius * 2} min={2} max={100} step={1} on:change={changeRadius}>
        { radius * 2}
    </Slider>
</label>

<h5>Fill</h5>
<Color color={fillColor} on:changeColor={changeFillColor}/>


<h5>Stroke</h5>
<Stroke {stroke} on:changeStyle={e => onChange(e.detail)} />

<style>
    label {
        display: inline-block;
    }
</style>